<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
          class="user-list-filters mb-3" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select :clearable="true" placeholder="" v-model="filters['status']" :options="['Active', 'In-Active']"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Frequency</label>
              <v-select :clearable="true" placeholder="" v-model="filters['frequency']" :options="frequencies"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Departments</label>
              <v-select :clearable="true" placeholder="" v-model="filters['departments']" :options="departments"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name" :reduce="dept => dept.id" multiple
                :closeOnSelect="false"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Staff</label>
              <v-select :clearable="true" v-model="filters['staff']" name="assignee" placeholder="" label="name"
                :reduce="option => option.id" :options="staffs" multiple :closeOnSelect="false" :searchable="true"
                :key="'staff-dropdown'" @search="onSearch" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template slot="no-options">
                  type to search staff
                </template></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Allocation</label>
              <v-select :clearable="true" v-model="filters['allocation']" name="allocation_type" placeholder="" 
                  :options="allocations"  
                 :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template slot="no-options">
                  type to search allocation type
                </template></v-select>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card title="Task Scheduling Manager" class="pt-1">
          <div slot="no-body" class="mt-4">
            <!-- tasks Table -->
            <div class="flex justify-end mb-4 mr-4">
              <vs-button @click="onClickCreateTask()" v-can="'create-edit-scheduled-tasks'" class="mr-4 mb-4" color="primary"
                type="filled">Create</vs-button>
            </div>
            <vs-table id="tasks-table" :data="tasks" stripe class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="thead">
                <vs-td>Code</vs-td>
                <vs-th>Name</vs-th>
                <vs-th>Template</vs-th>
                <vs-th>Start Date</vs-th>
                <vs-th>End Date</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Allocation</vs-th>
                <vs-th width="20%">Notes</vs-th>
                <vs-th>Status</vs-th>
                <vs-th class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="task in data" :key="task.id">
                  <vs-td>{{ task.code }}</vs-td>
                  <vs-td>{{ task.name }}</vs-td>
                  <vs-td>{{ task.scheduled_task_template.name }}</vs-td>
                  <vs-td>{{ task.start_date }}</vs-td>
                  <vs-td>{{ task.end_date ? task.end_date : 'N/A' }}</vs-td>
                  <vs-td>{{ task.allocation ? "System Event tasks" : "organisational tasks" }}</vs-td>
                  <vs-td>{{ task.allocation }}</vs-td>
                  <vs-td>{{ task.notes }}</vs-td>
                  <vs-td>{{ task.status }}</vs-td>
                  <vs-td>
                    <div class="vx-row" v-can="'create-edit-scheduled-tasks'">
                      <vx-tooltip text="Edit Task" position="top">
                        <vs-button class="mr-2" @click.stop="onClickViewTask(task)" size="small" color="primary"
                          type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="task.frequency == 'One Off' && task.allocation == undefined" text="Create Active Task" position="top">
                        <vs-button class="mr-2" @click.stop="onClickCreateTaskInstance(task)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-plus"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>
          </div>
        </vx-card>
      </div>
      <CreateTask ref="createTask" />
      <CreateTaskInstance ref="createTaskInstance" />
    </div>
  </div>

</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');
const DepartmentsRepository = RepositoryFactory.get('departments')
const DropDownRepository = RepositoryFactory.get('drop_down');
import Filter from '@/mixins/filter';
import { defaultPagination, perPageList } from "@/constants/config";
import CreateTask from "../../../components/popups/settings/scheduled-tasks/CreateTask.vue";
import vSelect from "vue-select";
import CreateTaskInstance from '../../../components/popups/settings/scheduled-tasks/CreateTaskInstance.vue';

export default {
  name: "ScheduledTasks",
  data() {
    return {
      filters: {},
      meta: {},
      page: 1,
      total: 0,
      perPage: defaultPagination,
      descriptionItems: perPageList,
      tasks: [],
      frequencies: [],
      departments: [],
      allocations: [],
      staffs: []
    };
  },
  mixins: [Filter],
  components: {
    CreateTask,
    CreateTaskInstance,
    'v-select': vSelect,
  },
  methods: {
    async fetchTasks() {
        await this.$vs.loading({
        container: '#tasks-table',
        scale: 0.45
      })
      try {
        const response = await ScheduledTasksRepository.listTask(this.filterQuery, this.perPage, this.page);
        this.tasks = response.data.data;
        this.meta = response.data.meta;
        this.$vs.loading.close('#tasks-table > .con-vs-loading')
      } catch (error) {
        console.error("Error fetching tasks:", error);
        this.$vs.loading.close('#tasks-table > .con-vs-loading')
      }
    },
    onClickViewTask(task) {
      this.$router.push({ path: `/pages/scheduled-tasks/${task.id}` })
    },
    onClickCreateTask() {
      this.$refs.createTask.openPopup(
      );
    },
    async onClickCreateTaskInstance(task) {
      this.$refs.createTaskInstance.openPopup(
        task
      );

    },
    refreshData() {
      this.fetchTasks();
    },
    filterQueryUpdate() {
      this.fetchTasks()
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchTasks()
    },
    async getFrequencies() {
      try {
        const { data } = await ScheduledTasksRepository.frequencies();
        this.frequencies = data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load frequencies:", err);
      }
    },
    async getAllocations() {
      try {
        const { data } = await ScheduledTasksRepository.allocations();
        // create a new array so Vue detects the change
        this.allocations = data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load allocations:", err);
      }
    },
    async getDepartments() {
      const { data } = await DepartmentsRepository.get(' ', '', '', '')
      this.departments = data.data
    },
    searchStaff: _.debounce(async (loading, search, vm) => {
      const { data } = await DropDownRepository.getStaffList(`filter[search]=${search}`)
      vm.staffs = data.data
      loading(false);
    }, 350),
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchStaff(loading, search, this);
      }
    },
  },
  async created() {
    await this.getFrequencies();
    await this.getAllocations();
    await this.getDepartments();
    await this.fetchTasks();
 
  },
    watch: {
    page(){
      this.fetchTasks()
    },
    perPage() {
      this.fetchTasks()
    }
  }
};
</script>
